import { useCallback, useState } from 'react';
import type { OutcomeSort } from './ranking';

export const OUTCOME_SORT_KEY = 'irm.eventMarketSort';

export function readStoredSort(
    storage: Pick<Storage, 'getItem'> | undefined
): OutcomeSort {
    try {
        const stored = storage?.getItem(OUTCOME_SORT_KEY);
        return stored === 'volume' || stored === 'flow'
            ? stored
            : 'probability';
    } catch {
        return 'probability';
    }
}

function browserStorage(): Storage | undefined {
    return typeof localStorage === 'undefined' ? undefined : localStorage;
}

export function useOutcomeSort(): [OutcomeSort, (sort: OutcomeSort) => void] {
    const [sort, setSort] = useState<OutcomeSort>(() =>
        readStoredSort(browserStorage())
    );
    const update = useCallback((next: OutcomeSort) => {
        setSort(next);
        try {
            browserStorage()?.setItem(OUTCOME_SORT_KEY, next);
        } catch {
            return;
        }
    }, []);
    return [sort, update];
}
